import script from "./ItParkEditPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItParkEditPage.vue?vue&type=script&setup=true&lang=ts"

import "./ItParkEditPage.vue?vue&type=style&index=0&id=9d9c3fbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d9c3fbe"]])

export default __exports__